/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const AcknowledgeIncidentHeaders = zod.object({
  'x-csrf-token': zod.string(),
});

export type AcknowledgeIncidentHeaders = zod.input<typeof AcknowledgeIncidentHeaders>;
export type AcknowledgeIncidentHeadersOutput = zod.output<typeof AcknowledgeIncidentHeaders>;
